import React, { useEffect } from 'react'
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { OwnProps } from '../../Utils/Types';
import { useAppSelector , useAppDispatch} from '../../hooks'
import { selectAuth , setToken } from "../../Pages/Login/store/login.Slice";
import { useNavigate } from 'react-router-dom';
import { getLsItem } from 'src/app/Utils';

const darkTheme = createTheme({
    typography: {
      fontFamily: [
        "Nunito",
        "sans-serif"
      ].join(",")
    }
  });

const PrivateLayout: React.FC<OwnProps> = (props: OwnProps) => {

  const auth = useAppSelector(selectAuth)
  const dispatch = useAppDispatch();
  const navigate = useNavigate()
  useEffect(() => {
    if(auth.isloggedIn){
      navigate('/dashboard', { replace: true })
    } else{
      navigate('/', { replace: true })
    }

  },[auth.isloggedIn])

  return (
    <ThemeProvider theme={darkTheme}>
      <CssBaseline />
      {props.children}
    </ThemeProvider>
  )
}

export default PrivateLayout